import { View, ScrollView } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import {
  StackActions,
  useFocusEffect,
  useNavigation,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { toast } from "react-toastify";
// import { ShowLoader } from "../../../../common/ShowLoader";
import { getLoginData } from "../../../../utility/AppStoreData";
import {
  fetchUserEvents,
  FetchUserPastEvents,
  fetchUserUpcomingEvents,
  fetchUserWatchingEvents,
} from "../../../../services/eventsAPI";
import { handleApiError } from "../../../../services/errorHandler";
import Separator from "../../../../Components/Separator";
import Header from "../Common/Header";
import MyEventHeader from "../../../../Components/myevent-components/MyEventHeader";
import { ScreenBGGradientView } from "../../../../common/CommonView";
import Cards from "../../../../Components/Cards";
import EventTypeScreen from "../../Event/EventTypeScreen";
import { useTooltips } from "../../../../context/WalkthroughContext";

const MyEventsScreen = ({ route }) => {
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const isGetUserProfileAPIRef = useRef(false);
  const [loginUserData, setLoginUserData] = useState(null);
  const [searchEvent, setSearchEvent] = useState("");
  const [kallOutIndex, setKallOutIndex] = useState(0);
  const [watchingIndex, setWatchingIndex] = useState(0);
  const [pastEventIndex, setPastEventIndex] = useState(0);
  const [showEventTypeModal, setShowEventTypeModal] = useState(false);
  const [isMyEvents, setIsMyEvents] = useState(false);
  const [userProfileData, setUserProfileData] = useState();
  const [accessToken, setAccessToken] = useState();
  const [username, setUsername] = useState("");
  const [kallOutEventArray, setKallOutEventArray] = useState([]);
  const [pastEventsArray, setPastEventsArray] = useState([]);
  const [upcomingEventsArray, setUpcomingEventsArray] = useState([]);
  const [watchingEventsArray, setWatchingEventsArray] = useState([]);
  const [showPastEventLoader, setShowPastEventLoader] = useState(false);
  const [showUpcomingEventLoader, setUpcomingEventLoader] = useState(false);
  const [showWatchingEventLoader, setShowWatchingEventLoader] = useState(false);
  const [showOrganisedEventLoader, setShowOrganisedEventLoader] =
    useState(false);
  const [organsiedLimit, setOrgansiedLimit] = useState(8);
  const [challengesIndex, setChallengesIndex] = useState(0);
  const [pastLimit, setPastLimit] = useState(8);
  const [upcomingLimit, setUpcomingLimit] = useState(8);
  const [watchingLimit, setWatchingLimit] = useState(8);
  const [pastLastEvaluatedKey, setPastLastEvaluatedKey] = useState(null);
  const [watchingLastEvaluatedKey, setWatchingLastEvaluatedKey] =
    useState(null);
  const [upcomingLastEvaluatedKey, setUpcomingLastEvaluatedKey] =
    useState(null);
  const [organsiedLastEvaluatedKey, setOrgansiedLastEvaluatedKey] =
    useState(null);
  const [isFetchingMoreOrgansiedEvents, setIsFetchingMoreOrgansiedEvents] =
    useState(false);
  const [isFetchingMorePastEvents, setIsFetchingMorePastEvents] =
    useState(false);
  const [isFetchingMoreUpcomingEvents, setIsFetchingMoreUpcomingEvents] =
    useState(false);
  const [isFetchingMoreWatchingEvents, setIsFetchingMoreWatchingEvents] =
    useState(false);
  const initialWatchingLoadRef = useRef(true);
  const initialOrgansiedLoadRef = useRef(true);
  const initialUpcomingLoadRef = useRef(true);
  const initialPastLoadRef = useRef(true);

  const getLoginUserData = async () => {
    if (isGetUserProfileAPIRef.current) {
      return;
    }
    const data = await getLoginData();

    if (data) {
      setLoginUserData(data);
      setUsername(data.username);
      getUserOrganisedAPI(data?.username, 8);
      getUserPastEventAPI(data?.AccessToken, 8);
      getUserUpcomingEventAPI(data?.username, 8);
      getUserWatchingEventAPI(data?.username, 8);
      setAccessToken(data?.AccessToken);
    }
    isGetUserProfileAPIRef.current = true;
  };

  const getUserOrganisedAPI = async (
    username,
    limit,
    paginationKey = undefined
  ) => {
    if (initialWatchingLoadRef.current) setShowOrganisedEventLoader(true);
    if (paginationKey) setIsFetchingMoreOrgansiedEvents(true);

    try {
      const data = await fetchUserEvents(username, limit, paginationKey);

      if (data.statusCode === 200) {
        const arrOrganised = data.body.organisedEvents ?? [];
        const lastKey = data.body.organisedLastEvaluatedKey;
        if (initialOrgansiedLoadRef.current) {
          setKallOutEventArray(arrOrganised);
          setOrgansiedLimit(5);
        } else {
          setKallOutEventArray((prev) => [...prev, ...arrOrganised]);
        }
        setOrgansiedLastEvaluatedKey((prevLastKey) => {
          if (prevLastKey && prevLastKey === lastKey) {
            // SAME KEY RETURNED AGAIN: stop fetching further
            return null;
          }
          return lastKey;
        });
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      if (paginationKey) setIsFetchingMoreOrgansiedEvents(false);
      setShowOrganisedEventLoader(false);
    }
  };

  const getUserPastEventAPI = async (
    accessToken,
    limit,
    paginationKey = undefined
  ) => {
    if (initialPastLoadRef.current) setShowPastEventLoader(true);
    if (paginationKey) setIsFetchingMorePastEvents(true);

    try {
      const data = await FetchUserPastEvents(accessToken, limit, paginationKey);

      if (data.statusCode === 200) {
        const arrPastEvent = data.body.events ?? [];
        const lastEvaluatedKey = data.body.lastEvaluatedKey;
        if (initialPastLoadRef.current) {
          setPastEventsArray(arrPastEvent);
          setPastLimit(5);
        } else {
          setPastEventsArray((prev) => [...prev, ...arrPastEvent]);
        }
        setPastLastEvaluatedKey((prevLastKey) => {
          if (prevLastKey && prevLastKey === lastEvaluatedKey) {
            // SAME KEY RETURNED AGAIN: stop fetching further
            return null;
          }
          return lastEvaluatedKey;
        });
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      if (paginationKey) setIsFetchingMorePastEvents(false);
      setShowPastEventLoader(false);
    }
  };

  const getUserUpcomingEventAPI = async (
    username,
    limit,
    paginationKey = undefined
  ) => {
    if (initialPastLoadRef.current) setUpcomingEventLoader(true);
    if (paginationKey) setIsFetchingMoreUpcomingEvents(true);

    try {
      const data = await fetchUserUpcomingEvents(
        username,
        limit,
        paginationKey
      );
      if (data.statusCode === 200) {
        const events = data.body.upcomingEvents ?? [];
        const lastKey = data.body.upcomingLastEvaluatedKey;
        if (initialUpcomingLoadRef.current) {
          setUpcomingEventsArray(events);
          setUpcomingLimit(5);
        } else {
          setUpcomingEventsArray((prev) => [...prev, ...events]);
        }
        setUpcomingLastEvaluatedKey((prevLastKey) => {
          if (prevLastKey && prevLastKey === lastKey) {
            // SAME KEY RETURNED AGAIN: stop fetching further
            return null;
          }
          return lastKey;
        });
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      if (paginationKey) setIsFetchingMoreUpcomingEvents(false);
      setUpcomingEventLoader(false);
    }
  };

  const getUserWatchingEventAPI = async (
    username,
    limit,
    paginationKey = undefined
  ) => {
    if (initialWatchingLoadRef.current) setShowWatchingEventLoader(true);
    if (paginationKey) setIsFetchingMoreWatchingEvents(true);

    try {
      const data = await fetchUserWatchingEvents(
        username,
        limit,
        paginationKey
      );

      if (data.statusCode === 200) {
        const events = data.body.eventsWatching ?? [];
        const lastKey = data.body.watchingLastEvaluatedKey;
        if (initialWatchingLoadRef.current) {
          setWatchingEventsArray(events);
          setWatchingLimit(5);
        } else {
          setWatchingEventsArray((prev) => [...prev, ...events]);
        }
        setWatchingLastEvaluatedKey((prevLastKey) => {
          if (prevLastKey && prevLastKey === lastKey) {
            // SAME KEY RETURNED AGAIN: stop fetching further
            return null;
          }
          return lastKey;
        });
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      if (paginationKey) setIsFetchingMoreWatchingEvents(false);
      setShowWatchingEventLoader(false);
    }
  };

  useEffect(() => {
    if (!isGetUserProfileAPIRef.current) {
      getLoginUserData();
      isGetUserProfileAPIRef.current = true;
    }
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      if (!isGetUserProfileAPIRef.current) {
        getLoginUserData();
        isGetUserProfileAPIRef.current = true;
      }
      return () => {};
    }, [])
  );

  const scrollViewRef = useRef(null);

  const { setCommonMyEventTooltipVisible, setTotalSteps, setCurrentStep } =
    useTooltips();

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {
          setCommonMyEventTooltipVisible(true);
          setTotalSteps(5);
          setCurrentStep(0);
        }}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
        displayTutorialButton={true}
      />

      <View style={[styles.container, {}]}>
        <MyEventHeader
          userData={loginUserData}
          isMyEvents={isMyEvents}
          setIsMyEvents={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
        />
        <View
          style={{
            paddingHorizontal:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "3.5%"
                : 0,
          }}
        >
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={1}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
        </View>

        <ScrollView
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          ref={scrollViewRef}
        >
          <Cards
            userData={loginUserData}
            eventID={""}
            heading="My KallOuts"
            CardData={kallOutEventArray}
            CardDataEmpty={kallOutEventArray.length === 0}
            accessToken={accessToken}
            showLoader={showOrganisedEventLoader}
            popularIndex={kallOutIndex}
            setPopularIndex={setKallOutIndex}
            userProfileData={userProfileData}
            screenName={"MyEvent"}
            lastEvaluatedKey={organsiedLastEvaluatedKey}
            eventlimit={organsiedLimit}
            isFetchingMorePopularEvents={isFetchingMoreOrgansiedEvents} // highlight
            fetchMoreEvents={() => {
              if (organsiedLastEvaluatedKey) {
                getUserOrganisedAPI(
                  username,
                  upcomingLimit,
                  upcomingLastEvaluatedKey
                );
              }
            }}
          />

          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>

          <Cards
            userData={loginUserData}
            eventID={""}
            heading="Opponents Challenges"
            CardData={upcomingEventsArray}
            CardDataEmpty={upcomingEventsArray.length === 0}
            accessToken={accessToken}
            showLoader={showUpcomingEventLoader}
            popularIndex={challengesIndex}
            setPopularIndex={setChallengesIndex}
            userProfileData={userProfileData}
            screenName={"MyEvent"}
            lastEvaluatedKey={upcomingLastEvaluatedKey}
            eventlimit={upcomingLimit}
            isFetchingMorePopularEvents={isFetchingMoreUpcomingEvents} // highlight
            fetchMoreEvents={() => {
              if (upcomingLastEvaluatedKey) {
                getUserUpcomingEventAPI(
                  username,
                  upcomingLimit,
                  upcomingLastEvaluatedKey
                );
              }
            }}
            scrollViewRef={scrollViewRef}
          />

          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>

          <Cards
            userData={loginUserData}
            eventID={""}
            heading="Events I'm Watching"
            CardData={watchingEventsArray}
            CardDataEmpty={watchingEventsArray.length === 0}
            accessToken={accessToken}
            showLoader={showWatchingEventLoader}
            popularIndex={watchingIndex}
            setPopularIndex={setWatchingIndex}
            userProfileData={userProfileData}
            screenName={"MyEvent"}
            lastEvaluatedKey={watchingLastEvaluatedKey}
            eventlimit={watchingLimit}
            isFetchingMorePopularEvents={isFetchingMoreWatchingEvents} // highlight
            fetchMoreEvents={() => {
              if (watchingLastEvaluatedKey) {
                getUserPastEventAPI(
                  username,
                  watchingLimit,
                  watchingLastEvaluatedKey
                );
              }
            }}
          />

          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            }}
          >
            <Separator
              color={AppColors.appGrayColor_1C1C1C}
              height={2}
              marginTop={0}
              marginBottom={0}
              marginHorizontal={0}
            />
          </View>

          <Cards
            userData={loginUserData}
            eventID={""}
            heading="Past Events"
            CardData={pastEventsArray}
            CardDataEmpty={pastEventsArray.length === 0}
            accessToken={accessToken}
            showLoader={showPastEventLoader}
            popularIndex={pastEventIndex}
            setPopularIndex={setPastEventIndex}
            userProfileData={userProfileData}
            screenName={"MyEvent"}
            lastEvaluatedKey={pastLastEvaluatedKey}
            eventlimit={pastLimit}
            isFetchingMorePopularEvents={isFetchingMorePastEvents} // highlight
            fetchMoreEvents={() => {
              if (pastLastEvaluatedKey) {
                getUserPastEventAPI(
                  accessToken,
                  pastLimit,
                  pastLastEvaluatedKey
                );
              }
            }}
          />
        </ScrollView>
      </View>

      {showEventTypeModal && (
        <EventTypeScreen
          showModal={showEventTypeModal}
          setShowModal={setShowEventTypeModal}
        />
      )}
    </View>
  );
};

export default MyEventsScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      container: {
        paddingHorizontal: 0,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        paddingHorizontal: 0,
      },
    },
  }
);
